var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01822 0H7.98178C3.57357 0 0 3.57357 0 7.98178V8.01822C0 12.4264 3.57357 16 7.98178 16H8.01822C12.4264 16 16 12.4264 16 8.01822V7.98178C16 3.57357 12.4264 0 8.01822 0Z",
    fill: "url(#paint0_linear_2163_4956)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4755 3.25513H5.52466C4.1569 3.25513 3.04419 4.36783 3.04419 5.73559V10.2649C3.04419 11.6327 4.1569 12.7454 5.52466 12.7454H10.4755C11.8433 12.7454 12.956 11.6327 12.956 10.2649V5.73559C12.956 4.36783 11.8433 3.25513 10.4755 3.25513ZM3.91922 5.73559C3.91922 4.85047 4.63954 4.13016 5.52466 4.13016H10.4755C11.3606 4.13016 12.0809 4.85047 12.0809 5.73559V10.2649C12.0809 11.15 11.3606 11.8703 10.4755 11.8703H5.52466C4.63954 11.8703 3.91922 11.15 3.91922 10.2649V5.73559Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00037 10.3069C9.27228 10.3069 10.3076 9.2721 10.3076 7.99964C10.3076 6.72717 9.27284 5.69238 8.00037 5.69238C6.72791 5.69238 5.69312 6.72717 5.69312 7.99964C5.69312 9.2721 6.72791 10.3069 8.00037 10.3069ZM8.00037 6.56797C8.7902 6.56797 9.4326 7.21037 9.4326 8.0002C9.4326 8.79002 8.7902 9.43242 8.00037 9.43242C7.21055 9.43242 6.56815 8.79002 6.56815 8.0002C6.56815 7.21037 7.21055 6.56797 8.00037 6.56797Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5211 6.06619C10.8636 6.06619 11.1427 5.78751 11.1427 5.44435C11.1427 5.10119 10.8641 4.82251 10.5211 4.82251C10.178 4.82251 9.89941 5.10119 9.89941 5.44435C9.89941 5.78751 10.178 6.06619 10.5211 6.06619Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2163_4956",
    x1: 2.33753,
    y1: 13.6625,
    x2: 13.6625,
    y2: 2.33809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramCircle);
export default __webpack_public_path__ + "static/media/instagram-circle.95c96310cc221eadf7dd54ca5e5a0803.svg";
export { ForwardRef as ReactComponent };